import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlServidor } from '../util/url-servidor';
import { Usuario } from '../api/dto/usuario';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  constructor(private http: HttpClient) { }

  private url : string = UrlServidor.URL_BASE + 'usuarios';

  buscarPorId(id?: number): Observable<Usuario> {
    return this.http.get<Usuario>(this.url + '/' + id);
  }

  buscarPorCpf(cpf?: string): Observable<Usuario> {
    return this.http.get<Usuario>(`${this.url}/cpf/${cpf}`);
  }

  buscarPorEmail(email?: string): Observable<Usuario> {
    return this.http.get<Usuario>(`${this.url}/email/${email}`);
  }

  buscarPorTipoECpfEEmpresa(tipo?: string, cpf?: string, empresaId?: number): Observable<Usuario> {
    return this.http.get<Usuario>(this.url + '/tipo/' + tipo + '/cpf/' + cpf + '/empresa/' + empresaId);
  }

  buscarPorTipoECpfEFranquia(tipo?: string, cpf?: string, franquiaId?: number): Observable<Usuario> {
    return this.http.get<Usuario>(this.url + '/tipo/' + tipo + '/cpf/' + cpf + '/franquia/' + franquiaId);
  }

  buscarPorTipoEEmailEEmpresa(tipo?: string, email?: string, empresaId?: number): Observable<Usuario> {
    return this.http.get<Usuario>(this.url + '/tipo/' + tipo + '/email/' + email + '/empresa/' + empresaId);
  }

  buscarPorTipoEEmailEFranquia(tipo?: string, email?: string, franquiaId?: number): Observable<Usuario> {
    return this.http.get<Usuario>(this.url + '/tipo/' + tipo + '/email/' + email + '/franquia/' + franquiaId);
  }

  listarTodos(): Observable<Usuario[]> {
    return this.http.get<Usuario[]>(this.url);
  }

  listarPorAdministradoraId(id?: number): Observable<Usuario[]> {
    return this.http.get<Usuario[]>(this.url + '/administradora/' + id);
  }

  listarPorEmpresaId(id?: number): Observable<Usuario[]> {
    return this.http.get<Usuario[]>(this.url + '/empresa/' + id);
  }

  listarPorEmpresaEDataCaixa(empresaId?: number, dataCaixa?: Date): Observable<Usuario[]> {
    return this.http.get<Usuario[]>(this.url + '/empresa/' + empresaId + '/caixa/' + dataCaixa);
  }

  salvar(usuario?: Usuario): Observable<Usuario> {
    return this.http.post<Usuario>(this.url + '/criar-conta', usuario);
  }

  atualizar(id?: number, usuario?: Usuario): Observable<Usuario> {
    return this.http.put<Usuario>(this.url + '/' + id, usuario);
  }

  atualizarPrimeiroAcesso(id?: number, usuario?: Usuario): Observable<Usuario> {
    return this.http.put<Usuario>(this.url + '/primeiro-acesso/' + id, usuario);
  }

  atualizarConta(usuario?: Usuario): Observable<void> {
    return this.http.put<void>(this.url + '/atualizar-conta', usuario);
  }

  resetarSenha(usuario?: Usuario): Observable<void> {
   return this.http.post<void>(this.url + '/resetar-senha', usuario);
  }

  
}
